'use strict';

exports.__esModule = true;
exports['default'] = addStyleSheet;
var stylesheetAdded = false;

function addStyleSheet(styles) {
    if (stylesheetAdded) return;
    stylesheetAdded = true;
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = styles;
    document.body.appendChild(style);
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-scrollbars/lib/utils/addStyleSheet.js
// module id = 216
// module chunks = 0 1 9